import { FC, SVGProps } from 'react'

export const ThumbsUpFilled: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.27245 0.727548L4.37452 2.62548C3.68271 3.31729 3.33681 3.66319 3.08944 4.06686C2.87012 4.42475 2.70851 4.81493 2.61052 5.22307C2.5 5.68342 2.5 6.1726 2.5 7.15097V7.3C2.5 8.4201 2.5 8.98016 2.71799 9.40798C2.90973 9.78431 3.21569 10.0903 3.59202 10.282C4.01984 10.5 4.5799 10.5 5.7 10.5H7.75466C8.72898 10.5 9.21614 10.5 9.60961 10.3217C9.9564 10.1646 10.2511 9.91172 10.4592 9.59286C10.6952 9.23107 10.7693 8.74957 10.9174 7.78658L11.0394 6.9941C11.1364 6.36313 11.185 6.04764 11.1577 5.78959C11.0703 4.96393 10.4819 4.2781 9.67917 4.06622C9.42827 4 9.10907 4 8.47068 4H8.13195C8.02994 4 7.97893 4 7.94143 3.99718C7.28876 3.94802 6.85849 3.29549 7.0704 2.67623C7.08258 2.64065 7.10267 2.59376 7.14286 2.5L7.53589 1.58293C7.75559 1.07028 7.37955 0.5 6.8218 0.5C6.61576 0.5 6.41815 0.581851 6.27245 0.727548Z"
      fill="currentColor"
    />
    <path
      d="M1.00012 4L1.00012 10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ThumbsUp: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.40325 9.86628L9.60961 10.3217L9.40325 9.86628C9.28073 9.9218 9.12515 9.95912 8.862 9.97916C8.5926 9.99966 8.2494 10 7.75466 10H5.7C5.1317 10 4.73554 9.99961 4.42712 9.97441C4.12454 9.94969 3.95069 9.9036 3.81901 9.83651C3.53677 9.6927 3.3073 9.46323 3.16349 9.18099C3.0964 9.04931 3.05031 8.87546 3.02559 8.57288C3.00039 8.26446 3 7.8683 3 7.3V7.15097C3 6.14881 3.00321 5.72922 3.09671 5.3398C3.18244 4.98267 3.32386 4.64126 3.51576 4.32811C3.72501 3.98664 4.01943 3.68767 4.72807 2.97904L6.62601 1.0811C6.67793 1.02917 6.74836 1 6.8218 1C7.02059 1 7.15462 1.20326 7.07631 1.38598L6.68329 2.30303C6.68072 2.30901 6.67819 2.31492 6.67569 2.32075C6.64308 2.39678 6.61582 2.46033 6.59734 2.51434L6.59734 2.51434C6.27946 3.44324 6.92487 4.42203 7.90388 4.49576C7.96079 4.50005 8.02991 4.50003 8.11261 4.5C8.11898 4.5 8.12542 4.5 8.13195 4.5H8.47068C9.14257 4.5 9.37956 4.50427 9.55157 4.54967C10.1537 4.70857 10.5949 5.22295 10.6605 5.84219C10.6792 6.0191 10.6473 6.25399 10.5452 6.91807L10.4233 7.71056C10.348 8.19953 10.2955 8.53869 10.2343 8.80185C10.1745 9.0589 10.1139 9.20699 10.0404 9.31964C9.88439 9.55879 9.66334 9.74843 9.40325 9.86628Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.00012 4L1.00012 10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
